<template>
	<div class="questionnaire-matrixFillBlank">
		<div class="questionnaire-title">{{title}}</div>
		<div class="questionnaire-matrixFillBlank-list">
			<div class="questionnaire-matrixFillBlank-label">
				<div v-for="(option, key) in options" :key="key">{{option}}</div>
			</div>

			<div class="questionnaire-matrixFillBlank-input">
				<div v-for="(option, key) in options" :key="key">
					<input :maxlength="maxlength" :disabled="disabled" v-model="componentValue[key]" @input="handleInput($event, key)" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			title: "",
			options: [],
			componentValue: []
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
            type: Array,
			default: () => {
				return []
			}
        },
        content: {
            type: String,
            default: ""
		},
        // options: {
        //     type: Array,
        //     default: () => {
        //         return []
        //     }
        // },
		disabled: {
			type: Boolean,
			default: false
		},
		maxlength: {
            type: String | Number,
            default: 50
        }
	},
	mounted() {
		this.componentValue = this.value
		const questionContent = this.content.split('@@@'), title = questionContent[0], options = questionContent[1].split('###')
		this.title = title
		this.options = options
	},
	methods: {
		/**
            输入框输入事件
            @param 
            @return
        */
		handleInput(event, key) {
			const value = event.target.value, componentValue = [...this.componentValue]
			componentValue[key] = value
			this.$emit('change', componentValue)
		}
	}
}
</script>

<style lang="scss" scoped>
.questionnaire-matrixFillBlank-list {
	display: flex;
	flex-direction: row;
	.questionnaire-matrixFillBlank-label {
		display: flex;
		flex-direction: column;
		margin-right: 0.16rem;
		
		>div {
			max-width: 2rem;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			height: 0.56rem;
			margin-bottom: 0.16rem;
		}
	}
	.questionnaire-matrixFillBlank-input {
		
		display: flex;
		flex-direction: column;
		
		>div {
			height: 0.56rem;
			width: 4rem;
			margin-bottom: 0.16rem;
			input {
				padding-left: 0.32rem;
				width: 100%;
				height: 100%;
				border: none;
				border-radius: 0.16rem;
				background-color: #EFEFEF;
				outline: none;
			}
		}
		
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/reserve/questionnaire/components/matrixFillBlank.vue